<template>
    <pm-welcome-screen v-if="firstRun" :steps="welcomeSteps" />
</template>
<script>
export default {
    data: () => ({
        firstRun: false,
    }),
    computed: {
        welcomeSteps() {
            return [
                {
                    title: 'Pro Consultation Tool',
                    description: 'Hundreds of millions treatment combinations and personalised 3D animations.<br/><br/>See how it works!',
                    bgImg: 'https://denticalc.com/assets/img/shot13.png',
                    imgStyle: {
                        backgroundSize: "120% auto",
                        backgroundPosition: "140% top",
                    },
                },
                {
                    title: 'Select a region',
                    description: 'First, click on a region or jaw where treatments need to be added.',
                    img: '/images/welcome/onboarding-country.png',
                    touch: true,
                    touchOffset: {
                        top: '33%',
                        left: '50%',
                    },
                },
                {
                    title: 'Add a treatment',
                    description: 'You can add multiple treatments to a region/jaw.',
                    img: '/images/welcome/onboarding-country.png',
                    touch: true,
                    touchOffset: {
                        top: '33%',
                        left: '50%',
                    },
                },
                {
                    title: 'Specify the tooth',
                    description: 'If needed, you can modify which teeth need to be treated.',
                    img: '/images/welcome/onboarding-country.png',
                    touch: true,
                    touchOffset: {
                        top: '33%',
                        left: '50%',
                    },
                },
                {
                    title: 'Show the prices',
                    description: 'Review the different options or add extra treatments. Don`t forget to fill your pricelist at one time!',
                    img: '/images/welcome/onboarding-country.png',
                    touch: true,
                    touchOffset: {
                        top: '33%',
                        left: '50%',
                    },
                },
                {
                    title: 'Animate',
                    description: 'Show the personalized 3D animation to your patient with a click. Simple as this!',
                    img: '/images/welcome/onboarding-country.png',
                    touch: true,
                    touchOffset: {
                        top: '33%',
                        left: '50%',
                    },
                },
            ];
        },
    },
    created() {
        return;
        if (window.packageName !== 'com.denticalc.4in1') return;
        if (localStorage.getItem('welcomeScreenPersonalizedShown') === null) {
            this.firstRun = true;
            localStorage.setItem('welcomeScreenPersonalizedShown_', 1);
        }
    },
}
</script>
